import { call, put, takeLatest } from 'redux-saga/effects';
import apiCall from '../helpers/ApiCall';
import apiRoot from '../consts/apiRoot';
import { POST } from '../consts/Methods';
import { SET_LOADER } from '../redux/Loader';
import { CREATE_PROMOTION, CREATE_PROMOTION_FAIIL, CREATE_PROMOTION_SUCCESS } from '../redux/Promotions';
import { SET_MODAL } from '../redux/Modal';

function* CreatePromotionFlow({ payload: { values, adId, channelId, }, }) {
  try {
    const hihlightsKeys = Object.keys(values).filter((item) => item.includes('highlight'));
    const highlights = hihlightsKeys.map((item) => values[item]);
    hihlightsKeys.forEach((key) => delete values[key]);

    const params = { promotion: { highlights, ...values, }, ad: { id: adId, }, channel: { uniq_name: channelId, }, };
    const endpoint = `${apiRoot}/promotions`;
    yield put(SET_LOADER({ value: true, }));
    const response = yield call(apiCall, { method: POST, endpoint, params, });
    yield put(CREATE_PROMOTION_SUCCESS(response));
  } catch (error) {
    yield put(CREATE_PROMOTION_FAIIL(error));
  } finally {
    yield put(SET_LOADER({ value: false, }));
    yield put(SET_MODAL({ componentName: 'PromotionFormModal', isCloseButtonShown: false, }));
  }
}

export default function* CreatePromotion() {
  yield takeLatest(CREATE_PROMOTION, CreatePromotionFlow);
}
